"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorWrap = exports.SubGroupWrap = exports.FilterButtonWrap = exports.FilterGroupWrap = exports.GroupWrapperWithButton = void 0;
/* eslint-disable max-len */
const styled_components_1 = __importDefault(require("styled-components"));
exports.GroupWrapperWithButton = styled_components_1.default.div `
  overflow: auto;
`;
exports.FilterGroupWrap = styled_components_1.default.div `
  display: grid;
  grid-template-columns: [boolean-start] 80px [boolean-end property-start] 120px [property-end opererator-start] 110px [operator-end value-start] auto [value-end menu-start] 32px [menu-end];
  grid-auto-rows: minmax(32px, auto);
  gap: 16px 8px;
  place-items: start stretch;
  align-items: center;
`;
exports.FilterButtonWrap = styled_components_1.default.div `
  margin-top: 16px;
  display: flex;
  gap: 16px;
`;
exports.SubGroupWrap = styled_components_1.default.div `
  grid-column: property-start / value-end;
  border-radius: 3px;
  box-shadow: rgb(55 53 47 / 10%) 0px 0px 0px 1px;
  margin: 1px;
  align-self: stretch;
`;
exports.OperatorWrap = styled_components_1.default.div `
  padding-left: 8px;
  height: 40px;
  line-height: 40px;
  background: var(--lowestBg);
  border-radius: 4px;
  text-align: left;
`;
